import { useNavigate } from "react-router-dom";

const StayInformedWithIndustryNews = () => {
  const navigate = useNavigate();
  return (
    <section className="w-full p-8 rounded-2xl bg-gray-50 dark:bg-[#0F172A]">
      <div className="container mx-auto">
        <div className="mx-auto p-6 bg-white dark:bg-[#182646] grid grid-cols-2 items-center justify-center gap-4 rounded-xl shadow-xl">
          <h3 className="text-green-600 font-semibold text-center ">
            Stay informed with industry news and insights
          </h3>
          <form className="flex flex-col md:flex-row items-center gap-4 justify-center">
            {/* <input
              type="email"
              name="email"
              placeholder="Enter your E-mail ID:"
              className="w-full md:flex-1 rounded-full border px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            /> */}
            <button
              type="button"
              className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6 py-2 transition"
              onClick={()=>navigate('/contact')}
            >
              Contact us
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default StayInformedWithIndustryNews;
